import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { css } from "styled-components";
import Label from "~/components-shared/Label";
const Wrapper = styled.div`
  ${_ref => {
  let {
    $display
  } = _ref;
  return $display && `display: ${$display}`;
}};
  ${_ref2 => {
  let {
    $s,
    theme
  } = _ref2;
  return theme.spacing.resolve(theme, $s);
}};

  label {
    color: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.text.secondary;
}};
  }
`;
const Switch = styled.span`
  height: 2.2rem;
  width: 4rem;
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
  background-color: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.background.primary;
}};
  margin: 2px 2px 5px;
  border-radius: 2.2rem;
  cursor: ${_ref5 => {
  let {
    $disabled
  } = _ref5;
  return $disabled ? "initial" : "pointer";
}};
  border: solid 1px ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.borders.primary;
}};
  box-shadow: inset 1px 1px 9px -3px rgba(4, 4, 4, 0.08), 1px 2px 6px -2px rgba(0, 0, 0, 0.01);
  transition: all 200ms ease-out;
  ${_ref7 => {
  let {
    $outline,
    theme
  } = _ref7;
  return theme.shadows.outline(theme, $outline);
}}

  ${_ref8 => {
  let {
    $active
  } = _ref8;
  return $active && css`
      background-color: ${_ref9 => {
    let {
      theme
    } = _ref9;
    return theme.colors.success.main;
  }};
      border: solid 1px transparent;
    `;
}}
`;
const Knob = styled.span`
  width: 1.87rem;
  height: 1.87rem;
  display: inline-block;
  background-color: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.name.includes("light") ? theme.colors.background.primary : theme.colors.text.primary;
}};
  border: solid 1px rgba(126, 126, 126, 0.07);
  box-shadow: 0 1px 3px rgba(107, 106, 106, 0.26), 0 5px 1px rgba(107, 106, 106, 0.13);
  border-radius: 2rem;
  margin: 1px 1px;
  transition: margin 200ms ease-out;

  opacity: ${_ref11 => {
  let {
    $disabled
  } = _ref11;
  return $disabled ? 0.5 : 1;
}}
    ${_ref12 => {
  let {
    active
  } = _ref12;
  return active && css`
        margin-left: 1.87rem;
      `;
}};

  ${_ref13 => {
  let {
    active
  } = _ref13;
  return active && css`
      margin-left: 1.87rem;
    `;
}}
`;
const Input = styled.input`
  opacity: 0;
  width: 0;
`;
const InputToggle = _ref14 => {
  let {
    value = false,
    onChange = () => false,
    label,
    disabled = false,
    display = "inline-block",
    outline,
    s = {},
    ...rest
  } = _ref14;
  const handleClick = e => {
    if (!disabled) {
      onChange(!value, e);
    }
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $s: s,
    $display: display
  }, rest), /*#__PURE__*/React.createElement(Switch, {
    $active: value,
    $outline: outline,
    onClick: handleClick,
    $disabled: disabled
  }, /*#__PURE__*/React.createElement(Knob, {
    active: value,
    $disabled: disabled
  }), /*#__PURE__*/React.createElement(Input, _extends({}, rest, {
    type: "checkbox",
    disabled: disabled
  }))), label && /*#__PURE__*/React.createElement(Label, {
    onClick: handleClick,
    s: {
      ml: 3
    },
    style: {
      cursor: disabled ? "initial" : "pointer"
    }
  }, label));
};
export default InputToggle;